// ...existing code...
<template>
  <div id="member-details" class="professional-member-details">
    <v-card class="member-details-card" elevation="3">
      <!-- Header -->
      <v-card-title class="member-card-header">
        <div class="header-content-single-row">
          <div class="title-section">
            <v-icon size="20" color="white" class="mr-2">mdi-account-circle</v-icon>
            <h3 class="member-card-title">{{ cardTitle }}</h3>
          </div>

          <div class="status-badges-inline">
            <v-tooltip
              top
              :disabled="Member.ProfileVerifiedTxt == 'Profile Complete'"
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  :color="Member.ProfileVerifiedTxtColor"
                  text-color="white"
                  x-small
                  class="status-chip-inline mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left size="12">
                    {{
                      Member.ProfileVerifiedTxt == "Profile Complete"
                        ? "mdi-check-circle"
                        : "mdi-alert-circle"
                    }}
                  </v-icon>

                  {{ Member.ProfileVerifiedTxt }}
                </v-chip>
              </template>
              <div class="missing-steps-tooltip" v-if="Member.MissingSteps != ''">
                <div class="tooltip-title">Missing Steps:</div>
                <div class="missing-steps-list">
                  {{
                    Member.MissingSteps 
                  }}
                </div>
              </div>
               <div class="missing-steps-tooltip" v-else>
                <div class="missing-steps-list">
                  {{
                    "Profile is complete."
                  }}
                </div>
              </div>
            </v-tooltip>

            <v-chip
              v-if="Member.document_flag == false"
              color="#ff9800"
              text-color="white"
              x-small
              class="status-chip-inline"
            >
              <v-icon left size="12">mdi-file-alert</v-icon>
              Age Proof Pending
            </v-chip>
            <v-chip
              v-else
              color="#4caf50"
              text-color="white"
              x-small
              class="status-chip-inline"
            >
              <v-icon left size="12">mdi-check-circle</v-icon>
              Age Proof Verified
            </v-chip>
          </div>
        </div>
      </v-card-title>

      <!-- Content -->
      <v-card-text class="member-card-content pa-4">
        <v-row class="member-info-row" align="center">
          <v-col cols="12" sm="4" md="3" class="avatar-section text-center">
            <div class="avatar-container">
              <v-avatar
                size="100"
                class="member-avatar elevation-4"
                v-if="Member.photo && Member.photo !== ''"
              >
                <v-img
                  :src="Member.photo"
                  :alt="Member.member_name"
                  class="avatar-image"
                ></v-img>
              </v-avatar>

              <v-avatar
                v-else
                size="100"
                color="#e3f2fd"
                class="member-avatar elevation-4"
              >
                <v-icon size="50" color="#1976d2">mdi-account</v-icon>
              </v-avatar>
            </div>
          </v-col>

          <v-col cols="12" sm="8" md="9" class="details-section">
            <v-row class="member-details-grid">
              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-account</v-icon>
                      <span class="detail-label">Full Name</span>
                    </div>
                    <div class="detail-value member-name">{{ Member.member_name || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-account-box</v-icon>
                      <span class="detail-label">Membership ID</span>
                    </div>
                    <div class="detail-value member-name">{{ Member.membership_id || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-email</v-icon>
                      <span class="detail-label">Email Address</span>
                    </div>
                    <div class="detail-value email-text">{{ Member.email_id || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-phone</v-icon>
                      <span class="detail-label">Mobile Number</span>
                    </div>
                    <div class="detail-value">{{ Member.mobile_no || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    cardTitle: {
      required: true,
      type: String,
    },
    Member: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      ProgessStart: 0,
      uploadPercentage: 0,
      RoleId: 0,
    };
  },
  methods: {
    refreshPageData() {
      // kept for parity with existing behaviour
      console.log("Member = ", this.Member);
    },
  },
  beforeMount() {
    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    this.RoleId = RoleId;
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.professional-member-details {
  .member-details-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(0, 0, 0, 0.08);

    &:hover {
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .member-card-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      padding: 16px 24px;

      .header-content-single-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
      }

      .member-card-title {
        font-size: 1.05rem;
        font-weight: 600;
        margin: 0;
        color: white;
      }

      .status-badges-inline {
        display: flex;
        align-items: center;
        gap: 8px;

        .status-chip-inline {
          font-weight: 500;
          font-size: 0.72rem;
          border-radius: 12px;
        }
      }
    }

    .member-card-content {
      background: #fafafa;
      min-height: 140px;
      padding: 18px;

      .avatar-section {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;

        .member-avatar {
          border: 4px solid white;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
          transition: transform 0.25s ease;
        }
      }

      .details-section {
        .member-details-grid {
          margin: 0;

          .detail-item {
            padding: 8px;

            .detail-card {
              background: white;
              padding: 14px 16px;
              border-radius: 8px;
              border: 1px solid rgba(0,0,0,0.06);
              box-shadow: 0 2px 8px rgba(0,0,0,0.06);
              min-height: 86px;
            }

            .detail-header {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 6px;
            }

            .detail-label {
              font-size: 0.72rem;
              font-weight: 600;
              color: #666;
              text-transform: uppercase;
            }

            .detail-value {
              font-size: 0.92rem;
              font-weight: 600;
              color: #222;
              margin-left: 24px;
              word-break: break-word;
            }

            .email-text {
              color: #1976d2;
            }
          }
        }
      }
    }
  }

  .missing-steps-tooltip {
    padding: 8px 0;

    .tooltip-title {
      font-weight: 700;
      font-size: 0.8rem;
      color: #fff;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    .missing-steps-list {
      font-size: 0.75rem;
      color: #fff;
      line-height: 1.4;
      white-space: normal;
      word-wrap: break-word;
    }
  }


  @media (max-width: 768px) {
    .member-details-card {
      .member-card-header { padding: 12px 16px; }
      .member-card-content { padding: 12px; }

      .member-avatar { width: 80px; height: 80px; }
      .detail-value { margin-left: 18px; font-size: 0.9rem; }
    }
  }
}
</style>
// ...existing code...